import { Component, OnInit } from '@angular/core';
import { OrdiniShowColumns } from '../../_models/OrdiniShowColumns';
import { ModalController } from '@ionic/angular';
import { LocalService } from '../../_services/local.service';
import { constants } from '../../_helpers/constants';
import { LicenzeService } from '../../_services/licenze.service';

interface ShowColumn {
  key: keyof OrdiniShowColumns;
  label: string;
  active: boolean;
  requiresPermission?: string;
}

const allColumns: Omit<ShowColumn, 'active'>[] = [
  { key: 'numRegistrazione', label: 'Num. registrazione' },
  { key: 'commessa',         label: 'Commessa' },
  { key: 'rifOrdine',        label: 'Rif. ordine (barcode)', requiresPermission: constants.MOD_PRO_BASE_BARCODE },
  { key: 'idDocumento',      label: 'ID documento' },
  { key: 'rifOdP',           label: 'Rif. ordine' },
  { key: 'numFase',          label: 'Num. fase' },
  { key: 'dataRegistrazione',label: 'Data registrazione' },
  { key: 'dataTermine',      label: 'Data termine' },
  { key: 'risorsa',          label: 'Risorsa' },
  { key: 'lavorazione',      label: 'Lavorazione' },
  { key: 'codiceArticolo',   label: 'Codice articolo' },
  { key: 'varianteArt',      label: 'Variante articolo' },
  { key: 'idOrdVen',         label: 'Ordine cliente' },
  { key: 'codCliente',       label: 'Codice Cliente' },
  { key: 'codTerzista',      label: 'Codice terzista' },
  { key: 'udM',              label: 'Unità misura' },
  { key: 'quantita',         label: 'Quantità' },
  { key: 'quantitaToDo',     label: 'Quantità residua' },
  { key: 'stato',            label: 'Stato' },
];

const defaultActiveKeys: (keyof OrdiniShowColumns)[] = [
  'numRegistrazione', 'rifOdP', 'dataTermine', 'risorsa',
  'lavorazione', 'codiceArticolo', 'quantita', 'stato'
];

@Component({
    selector: 'app-ordini-show-columns',
    templateUrl: './ordini-show-columns.component.html',
    styleUrls: ['./ordini-show-columns.component.scss'],
    standalone: false
})
export class OrdiniShowColumnsComponent implements OnInit {
  columns: ShowColumn[] = [];

  constructor(
    public licenseService: LicenzeService,
    private modalCtrl: ModalController,
    private localService: LocalService
  ) {}

  ngOnInit() {
    const saved = this.localService.showColumns.value;
    this.columns = allColumns
      .filter(c => !c.requiresPermission || this.licenseService.checkPermesso(c.requiresPermission))
      .map(c => ({ ...c, active: !!saved[c.key] }));
  }

  cancel = () => this.modalCtrl.dismiss(false, 'cancel');

  handleReorder(ev: CustomEvent) {
    this.columns = ev.detail.complete(this.columns);
  }

  resetDefault() {
    this.columns.forEach(c => { c.active = defaultActiveKeys.includes(c.key); });
    this.succesSave();
  }

  succesSave() {
    const updated: OrdiniShowColumns = {};
    this.columns.forEach(c => { (updated as any)[c.key] = c.active; });
    this.localService.setOrdiniShowColumns(updated);
    this.modalCtrl.dismiss(true, 'confirm');
  }
}
